import React from "react";
import { cn } from "../../DashboardPage/lib/utils";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Accessible name. Required — the switch renders no visible text of its own. */
  label: string;
  disabled?: boolean;
  className?: string;
}

/**
 * The single toggle-switch definition: primary-700 track when on, neutral
 * when off, white knob. Rendered as a real `role="switch"` so screen readers
 * announce its state (the hand-rolled versions this replaces were unlabelled
 * buttons).
 */
export default function ToggleSwitch({
  checked,
  onChange,
  label,
  disabled = false,
  className,
}: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative inline-flex items-center h-6 p-1 transition-colors rounded-full shrink-0 w-11",
        "border border-transparent focus:outline-none focus-visible:border-primary-700",
        checked ? "bg-primary-700" : "bg-neutral-300",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "w-4 h-4 transition-transform bg-white rounded-full shadow-sm",
          checked ? "translate-x-5" : "translate-x-0"
        )}
      />
    </button>
  );
}
